/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo, MouseEventHandler} from 'react';
import {translate} from '@ion/core/src/locale/locale';
import {TertiaryButton} from '../../components/buttons/TertiaryButton';

interface BackButtonProps {
  onBack: MouseEventHandler;
  disabled?: boolean;
};

/**
 * Displays a common 'Back' button.
 *
 * ```typescript
 *
 *    import {BackButton} from '@ion/dls/src/editors/controls';
 *
 *    <BackButton disabled={false} onBack={onBack} />
 *
 * ```
 */
export const BackButton = ({onBack, disabled = false}: BackButtonProps) => (
  <TertiaryButton onClick={onBack} disabled={disabled}>
    {translate('common:editors.shared.back')}
  </TertiaryButton>
);

export default memo(BackButton);
